"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ErrorSummary;
exports.getUniqueIdentifier = exports.getPostFix = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.map.js");
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _utils = require("../utils");
var _utils2 = require("../../utils");
var _lodash = _interopRequireDefault(require("lodash"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getPostFix = exports.getPostFix = function getPostFix(_ref) {
  var unit = _ref.unit,
    intf = _ref.intf;
  if (intf === 'weight_intl' || intf === 'height_intl') {
    if ((0, _utils2.isEmpty)(unit) || unit === 'all') {
      return '_select_unit_type';
    }
  }
  if ((0, _utils2.isEmpty)(unit)) {
    return '';
  }
  switch (String(unit).toLocaleLowerCase()) {
    case 'stone':
      return '_stones';
    case 'imperial':
      return '_feet';
    case 'metric':
      if (intf === 'weight_intl') {
        return '_kilograms';
      } else {
        return '_centimeters';
      }
    default:
      return "_".concat(unit);
  }
};
var getUniqueIdentifier = exports.getUniqueIdentifier = function getUniqueIdentifier(_ref2) {
  var name = _ref2.name,
    unit = _ref2.unit,
    intf = _ref2.intf,
    possible_answers = _ref2.possible_answers;
  switch (intf) {
    case 'radio':
    case 'checkboxWithNone':
      return (0, _utils2.buildUniqueId)(name, possible_answers[0].label, possible_answers[0].answer);
    default:
      return "t-".concat(name).concat(getPostFix({
        unit: unit,
        intf: intf
      }));
  }
};
function ErrorSummary(props) {
  var _errorInformation$any;
  var errorInformation = props.errorInformation,
    setFirstErrorElement = props.setFirstErrorElement;
  var summaryRef = (0, _react.useRef)(null);
  var touched = (0, _react.useRef)((_errorInformation$any = errorInformation.anyTouched) !== null && _errorInformation$any !== void 0 ? _errorInformation$any : false);
  var firstLinkRef = (0, _react.useRef)(null);
  var location = (0, _reactRouterDom.useLocation)();
  (0, _react.useEffect)(function () {
    if (location.hash) {
      var element = document.querySelector(location.hash);
      if (element) {
        // Smoothly scroll to the element
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, [location]);
  (0, _react.useEffect)(function () {
    if (!touched.current && errorInformation.anyTouched) {
      touched.current = true;
      if (summaryRef && summaryRef.current.scrollIntoView) {
        summaryRef.current.scrollIntoView();
      }
      if (errorInformation.anyTouched && firstLinkRef && firstLinkRef !== null && firstLinkRef !== void 0 && firstLinkRef.current) {
        var _firstLinkRef$current, _firstLinkRef$current2, _firstLinkRef$current3;
        firstLinkRef === null || firstLinkRef === void 0 ? void 0 : (_firstLinkRef$current = firstLinkRef.current) === null || _firstLinkRef$current === void 0 ? void 0 : (_firstLinkRef$current2 = _firstLinkRef$current.children) === null || _firstLinkRef$current2 === void 0 ? void 0 : (_firstLinkRef$current3 = _firstLinkRef$current2[0]) === null || _firstLinkRef$current3 === void 0 ? void 0 : _firstLinkRef$current3.focus();
        setFirstErrorElement(firstLinkRef);
      }
    }
  }, [errorInformation]);
  var errors = (0, _react.useMemo)(function () {
    var errorArr = [];
    if (errorInformation !== null && errorInformation !== void 0 && errorInformation.syncErrors) {
      Object.keys(errorInformation.syncErrors).forEach(function (key) {
        errorArr.push({
          key: key,
          message: errorInformation.syncErrors[key]
        });
      });
    }
    return errorArr;
  }, [errorInformation]);
  var focusInput = function focusInput(input) {
    var identifier = getUniqueIdentifier(_objectSpread(_objectSpread({}, input), {}, {
      unit: input.unit_type,
      intf: input["interface"]
    }));
    var element = document.getElementById(identifier);
    try {
      element.blur();
      element === null || element === void 0 ? void 0 : element.focus({});
    } catch (error) {
      console.error(error);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: summaryRef,
    role: "alert"
  }, props !== null && props !== void 0 && props.errorInformation.anyTouched && errors !== null && errors !== void 0 && errors.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-summary--container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-summary--title"
  }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, props === null || props === void 0 ? void 0 : props.label)), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "error-summary--item-container"
  }, errors === null || errors === void 0 ? void 0 : errors.map(function (err, idx) {
    var _props$errorInformati;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "".concat(err.key, "_error-message"),
      ref: idx === 0 && firstLinkRef ? firstLinkRef : undefined,
      className: "error-summary--item"
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "#t-".concat(err.key, "_error-message_"),
      className: "error-summary--item-link",
      "data-testid": "".concat(err.key, "_error-message_"),
      onClick: function onClick() {
        return focusInput(props.errorInformation.inputsWithError[err.key]);
      },
      "aria-label": "".concat(err.message).concat((_props$errorInformati = props.errorInformation.inputsWithError[err.key]) !== null && _props$errorInformati !== void 0 && _props$errorInformati.label ? " - ".concat((0, _utils.stripHtml)(props.errorInformation.inputsWithError[err.key].label)) : '')
    }, err.message));
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null));
}